export default __webpack_public_path__ + "static/media/lucban-genesis-logo.ecf91c0f.png";